module.exports = __webpack_public_path__ + "img/avatar.4fe1c3aa.png";